import { Injectable } from '@angular/core';
import { BinaryWriter } from 'google-protobuf';
import { Link } from '../../../libs/proto/commUnity_pb';

@Injectable({
  providedIn: 'root'
})
export class LinksConversionService {

  constructor() { }

  ToStorage(req: Link) {
    const w = new BinaryWriter();
    Link.serializeBinaryToWriter( req, w);

    const abuf = w.getResultBuffer();
    return Array.from // if available
              ? Array.from(abuf) // use Array#from
              : abuf.map(v => v);
  }

  FromStorage(data: any, callback: (link: Link, errorConvert: any) => void) {
    try {
      callback( Link.deserializeBinary(data), null);
    } catch (error) {
      callback( null, error);
    }
  }

  ToStorages(link: Link[]) {
    const rets = new Array<Uint8Array | number[]>();

    link.forEach(element => {
      rets.push(
        this.ToStorage(element)
      );
    });

    return {data: rets};
  }

  FromStorages(data: any, callback: (link: Link[], errorConvert: any) => void) {
    if (data == null) {
      callback(null, Error('empty'));
      return;
    }
    const emps = new Array<Link>();
    const empjs: {data: (Uint8Array)[]} = data;
    try {

      empjs.data.forEach(element => {
        const emp = Link.deserializeBinary( element  );
        emps.push ( emp );
      });

      callback( emps, null);
    } catch (error) {
      callback( null, error);
    }
  }
}
